<template>
  <div class="orders-table">
    <base-table
      button-class="btn btn-accent-1"
      :fields="fields"
      :items="filteredOrders"
      :actions="actions"
      :columns="columns"
      :loading="loading"
      use-action-icons
      animate-row-details>
      <template #loading>
        <slot name="loading" />
      </template>
      <template #row-details="{data}">
        <order-details :sop-lines="data.item.sopLines"></order-details>
      </template>
    </base-table>
  </div>
</template>

<script>
import { subDays, subMonths, subYears } from "date-fns";
import { BaseTable, DateUtilsModule } from "spiritweb.packages.web-account";
import { EcommerceModule } from "spiritweb.packages.ecommerce";
import OrderDetails from "~/Components/Accounts/OrderHistory/OrderDetails.vue";

export default {
  name: "OrdersTable",
  components: {
    BaseTable,
    OrderDetails,
  },
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
    dateFilter: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: null,
    },
  },
  data () {
    return {
      fields: [
        {
          key: "reference",
          label: "#",
        },
        {
          key: "dateSubmitted",
          label: "Date Ordered",
          renderer: this.formatDate,
        },
        {
          key: "person",
          label: "Purchased by",
        },
        {
          key: "organisation",
          label: "Organisation",
        },
        {
          key: "poRef",
          label: "PO",
        },
        {
          key: "statusDescription",
          label: "Order Status",
        },
        {
          key: "sopLines",
          label: "Items in Order",
          renderer: this.getItemsInOrder,
        },
        {
          key: "totalExcludingVat",
          label: "Total Cost Exc VAT",
          renderer: this.formatPrice,
        },
        {
          key: "actions",
          label: "",
        },
      ],
      actions: [
        {
          action: "toggleRowDetails",
          icon: ["fas", "eye"],
        },
      ],
    };
  },
  computed: {
    filteredOrders () {
      let result = null;
      const orders = this.orders.filter(
        o => o.statusSystemCode?.toLowerCase() !== "active"
        && o.statusSystemCode?.toLowerCase() !== "abandoned",
      );

      switch ( this.dateFilter ) {
        case "month": {
          result = orders.filter(
            o => new Date( o.displayDate ) >= new Date( subDays( Date.now(), 30 ) ),
          );
          break;
        }
        case "six-months": {
          result = orders.filter(
            o => new Date( o.displayDate ) >= new Date( subMonths( Date.now(), 6 ) ),
          );
          break;
        }
        case "year": {
          result = orders.filter(
            o => new Date( o.displayDate ) >= new Date( subYears( Date.now(), 1 ) ),
          );
          break;
        }
        case "all":
        default:
          result = orders;
          break;
      }

      return result;
    },
  },
  methods: {
    formatDate ( date ) {
      let result = null;
      if ( date !== null ) {
        result = DateUtilsModule.formatDate( date, DateUtilsModule.dateFormats.readable );
      }
      return result;
    },
    formatPrice ( input ) {
      return EcommerceModule.renderPrice( input, "gbp", "en-gb" );
    },
    getItemsInOrder ( item ) {
      let result = 0;

      if ( item ) {
        result = item.length;
      }

      return result;
    },
  },
};
</script>

<style lang="less" scoped>
.orders-table {
  overflow-x: auto;
}
</style>
